import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Clinic } from '@web/csl-lib-models';
import { HttpClient } from '@angular/common/http';
import { SERVICE_CONFIG_TOKEN, ServiceConfig } from '@web/csl-lib-services';

@Injectable({
  providedIn: 'root'
})
export class SurvivorClinicService {

    /* Member Vars */
    private serviceConfig: ServiceConfig;
    private http!: HttpClient;
    private readonly apiUrl! : string;


    /* Lifecycle Hooks */
    constructor() {
      this.http = inject(HttpClient);
      this.serviceConfig = inject(SERVICE_CONFIG_TOKEN);
      this.apiUrl = this.serviceConfig.apiUrl;
    }


    /* Event Handlers */


    /* Instance Methods */

    // Get the specified clinic
    getClinic(clinicId: number): Observable<Clinic> {
      return this.http.get<Clinic>(`${this.apiUrl}/clinics/${clinicId}`);
    }

}
